var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showCarousel)?_c('DealStoryCarousel',_vm._b({},'DealStoryCarousel',_vm.componentProps,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }